import { render, staticRenderFns } from "./uebungen.vue?vue&type=template&id=c5cc6932&"
import script from "./uebungen.vue?vue&type=script&lang=js&"
export * from "./uebungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports